import type { Device } from '@/features/devices/types/device'
import { apiClient } from '@/lib/api/api-client'

export const apiGetDevice = (id: number | string) =>
  apiClient<Device>(`/api/v1/devices/${id}`)
